import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommentPopupComponent } from './comment-popup.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { DropdownModule } from '../dropdown/dropdown.module';
import { FocusSelectDirective } from '../directives/focus-select.directive';
import { TranslateModule } from '@ngx-translate/core'; 
import { ActionMenuDirective } from '../action-menu/action-menu.directive';
import { ActionMenuComponent } from '../action-menu/action-menu.component';

@NgModule({
  declarations: [CommentPopupComponent],
  imports: [
    CommonModule,
    DropdownModule,
    FocusSelectDirective,
    TranslateModule,
    ActionMenuDirective,
    ActionMenuComponent
  ],
  exports: [CommentPopupComponent, DropdownComponent],
})
export class CommentPopupModule {}
